import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=07cabfb6&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cabfb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07cabfb6')) {
      api.createRecord('07cabfb6', component.options)
    } else {
      api.reload('07cabfb6', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=07cabfb6&scoped=true&", function () {
      api.rerender('07cabfb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jGaReK7VcLjn/JS/comp/Voucher-Unit.vue"
export default component.exports